import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { List } from "./MilestoneTaskPicker";
import { Draggable, Droppable, DroppableProvided } from "react-beautiful-dnd";
import { getItemStyle } from "helpers/dragAndDropUtils";
import dragIcon from "assets/drag_and_drop_icon.png";
import SearchIcon from "assets/Icon_Form_Search_01.png";
import CrossIcon from "assets/Icon_Form_Search_02.png";
interface Props {
  list: List[];
  startIndex: number;
  type: "milestone" | "task";
  tempTriggerMilestoneData: List | null;
  setTempTriggerMilestoneData: React.Dispatch<SetStateAction<List | null>>;
  tempTriggerMilestoneId: number | null;
  setTempTriggerMilestoneId: React.Dispatch<SetStateAction<number | null>>;
  tempActionMilestoneData: List | null;
  setTempActionMilestoneData: React.Dispatch<SetStateAction<List | null>>;
  tempActionMilestoneId: number | null;
  setTempActionMilestoneId: React.Dispatch<SetStateAction<number | null>>;
  setShowAddPage: React.Dispatch<SetStateAction<boolean>>;
}

const MilestoneTaskList: React.FC<Props> = ({
  list,
  startIndex,
  type,

  tempTriggerMilestoneData,
  setTempTriggerMilestoneData,
  tempTriggerMilestoneId,
  setTempTriggerMilestoneId,
  tempActionMilestoneData,
  setTempActionMilestoneData,
  tempActionMilestoneId,
  setTempActionMilestoneId,
  setShowAddPage,
}) => {
  const [search, setSearch] = useState<string>("");
  const [filteredList, setFilteredList] = useState<List[]>([...list]);

  useEffect(() => {
    setFilteredList(list);
  }, [list]);

  useEffect(() => {
    if (tempTriggerMilestoneId && filteredList) {
      const match = filteredList.filter((item: any) => item.tasksId === tempTriggerMilestoneId);

      if (Array.isArray(match) && match.length === 1) {
        setTempTriggerMilestoneData(match[0]);
      }
    }
  }, [tempTriggerMilestoneId]);

  useEffect(() => {
    if (tempActionMilestoneId && filteredList) {
      const match = filteredList.filter((item: any) => item.tasksId === tempActionMilestoneId);

      if (Array.isArray(match) && match.length === 1) {
        setTempActionMilestoneData(match[0]);
      }
    }
  }, [tempActionMilestoneId]);

  return (
    <div className="TaskListContainer">
      {type === "milestone" && (
        <div className="Title">
          <div className="Text">Milestones</div>
        </div>
      )}
      {type === "task" && (
        <div className="Title">
          <div className="Text">Tasks</div>
        </div>
      )}

      <SearchList
        setFilteredList={setFilteredList}
        search={search}
        setSearch={setSearch}
        list={list}
      />
      {/* <input type="text" value={searchString} onChange={handleSearch} /> */}

      <Droppable droppableId={`droppableId-${type}-${1}`} type="group">
        {(provided) => (
          <div className="TaskList" ref={provided.innerRef} {...provided.droppableProps}>
            {filteredList &&
              filteredList.map((items, idx) => (
                <Draggable
                  draggableId={`draggable-${items.tasksName}-${items.tasksId}`}
                  key={`draggable-${items.tasksName}-${idx}`}
                  index={startIndex + idx}
                >
                  {(provided, snapshot) => {
                    return (
                      <div
                        className={`GatewayTasksItem`}
                        key={`gateway-tasks-item-${idx}`}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                      >
                        <img
                          src={dragIcon}
                          alt="drag task"
                          className="DragIcon DraggableArea"
                          key={`gateway-tasks-item-drag-icon-${idx}`}
                        />
                        <div className="Name" key={`gateway-tasks-item-name-${idx}`}>
                          {items.tasksName ?? ""}
                        </div>
                      </div>
                    );
                  }}
                </Draggable>
              ))}

            {provided.placeholder}
          </div>
        )}
      </Droppable>

      {/* <div
        className="Btn"
        onClick={() => {
          setShowAddPage(true);
        }}
      >
        Add new milestones/tasks
      </div> */}
    </div>
  );
};

export default MilestoneTaskList;
interface SearchProps {
  search: string;
  setSearch: Dispatch<SetStateAction<string>>;
  setFilteredList: Dispatch<SetStateAction<List[]>>;
  list: List[];
}

const SearchList: React.FC<SearchProps> = ({ search, setSearch, setFilteredList, list }) => {
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchString = e.target.value;
    if (searchString !== "") {
      setFilteredList(
        list.filter((item) => item.tasksName.toLowerCase().includes(searchString.toLowerCase()))
      );
    } else {
      setFilteredList([...list]);
    }
    setSearch(e.target.value);
  };

  const clearSearch = () => {
    setSearch("");
    setFilteredList([...list]);
  };

  const isEmpty = search === "";

  return (
    <div className="SearchBoxContainer ListSearchBox">
      <input
        style={{ backgroundColor: "white" }}
        className="SearchBox"
        placeholder="Type your search here"
        value={search}
        onChange={handleSearch}
      />

      {isEmpty && (
        <img src={SearchIcon} alt="Search" className="SearchIcon" onClick={clearSearch} />
      )}

      {!isEmpty && (
        <img src={CrossIcon} alt="Clear" className="ClearSearchIcon" onClick={clearSearch} />
      )}
    </div>
  );
};
